import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';

const ROLE_LABELS = {
  WAITER: 'Waiter',
  CHEF: 'Chef',
  SOUS_CHEF: 'Sous chef',
  KITCHEN_HELPER: 'Kitchen helper',
  CAPTAIN: 'Captain',
  STEWARD: 'Steward',
  CASHIER: 'Cashier',
  CLEANER: 'Cleaner',
  DISHWASHER: 'Dishwasher',
  MANAGER: 'Manager',
  DELIVERY: 'Delivery',
  OTHER: 'Other',
};

const JOB_ROLES = Object.keys(ROLE_LABELS);

const SELECT_CLASS =
  'py-2 pl-3 pr-8 text-sm rounded-lg border border-gray-300 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-500 transition';

function FilterBar({ search, onSearchChange, role, onRoleChange, status, onStatusChange }) {
  const [localSearch, setLocalSearch] = useState(search);
  const timerRef = useRef(null);

  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  const handleSearchInput = (e) => {
    const val = e.target.value;
    setLocalSearch(val);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onSearchChange(val), 150);
  };

  return (
    <div className="flex flex-wrap items-center gap-3 px-6 pb-4">
      <div className="relative flex-1 min-w-[200px] max-w-xs">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
        <input
          type="text"
          placeholder="Search by name or phone…"
          value={localSearch}
          onChange={handleSearchInput}
          className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-500 transition"
        />
      </div>

      <select value={role} onChange={e => onRoleChange(e.target.value)} className={SELECT_CLASS}>
        <option value="">All roles</option>
        {JOB_ROLES.map(r => (
          <option key={r} value={r}>{ROLE_LABELS[r]}</option>
        ))}
      </select>

      <select value={status} onChange={e => onStatusChange(e.target.value)} className={SELECT_CLASS}>
        <option value="active">Active only</option>
        <option value="all">Include inactive</option>
        <option value="inactive">Inactive only</option>
      </select>
    </div>
  );
}

export default FilterBar;